import styled from "styled-components";
import media from "../../static/style/media";

export const Container = styled.div`
  margin: 0 auto;
  max-width: 1300px;
`;

export const MapContainer = styled.div`
  margin-top: 5px;
  margin-bottom: 40px;
  border-radius: 12px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  width: 100%;
  height: auto;
`;

export const Text = styled.h1`
  margin-top: 10px;
  color: #b2b2b2;
  font-size: 1.5rem;
  text-align: center;
  ${media.small`
    font-size: 1.2rem;
  `}
`;

export const TableContainer = styled.div`
  position: relative;
  height: 500px;
  overflow-y: auto;
  overflow-x: hidden;
  margin-bottom: 30px;
  margin-top: 5px;
  background-color: #fafafa;
  border-radius: 12px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.05);
`;

export const TableItem = styled.td`
  text-align: center;
  font-size: 1rem;
  height: 50px;
  line-height: 50px;
  padding: 10px 15px;
  color: #333;
  position: relative; /* 부모 요소에 상대 위치 설정 */
  &::after {
    content: '';
    position: absolute;
    top: 20%; /* 구분선이 상단에서 20% 시작 */
    bottom: 20%; /* 구분선이 하단에서 20% 끝 */
    right: 0;
    width: 1px;
    background-color: rgba(0, 0, 0, 0.05);
  }
  &:last-child::after {
    content: none; /* 마지막 열에는 구분선 없애기 */
  }
  ${media.small`
    font-size: 0.9rem;
    height: 40px;
    line-height: 40px;
  `}
`;

export const TableGridContainer = styled.tr`
  background-color: ${(props) => props.color || "#fff"};
  height: 50px;
  line-height: 50px;
  cursor: pointer;
  transition: all 0.3s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05); /* 얇은 하단 구분선 */
  &:hover {
    background-color: #eaf4ff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1); /* 부드러운 호버 효과 */
    transform: translateY(-2px); /* 살짝 떠오르는 효과 */
  }
`;

export const ContentContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 15px 15px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1); /* 은은한 하단 경계선 */
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.05); /* 살짝 그림자 */
  margin-bottom: 20px; /* 아래 컴포넌트와의 간격 */
  overflow: hidden;
  
  @media (max-width: 768px) {
    flex-direction: column; /* 모바일에서는 세로로 배치 */
  }
`;


export const ButtonContainer = styled.div`
  grid-column: 1 / -1; /* 전체 행을 차지하는 버튼 */
  display: flex;
  height: 100%;
  justify-content: flex-end;
  padding-top: 10px;
  white-space: pre;
  
  @media (max-width: 768px) {
    grid-column: 1 / -1; /* 모바일에서도 전체 행 차지 */
    justify-content: center; /* 모바일에서는 중앙에 배치 */
  }
`;

export const SearchBtnContainer = styled.div`
  grid-column: span 1; /* Spans only one column on larger screens */
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(135deg, #6f86d6, #48c6ef);
  border: none;
  border-radius: 5px;
  padding: 10px 20px;
  color: #fff;
  font-size: 1.2em;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    background: linear-gradient(135deg, #48c6ef, #6f86d6);
    transform: scale(1.05);
  }

  @media (max-width: 768px) {
    grid-column: span 1; /* Spans only one column on mobile */
    width: 100%; /* Make button take full width on mobile */
    justify-content: center;
  }
`;


export const SelectDevice = styled.select`
  height: 40px;
  width: 200px;
  background-color: #f7f7f7; /* 배경을 밝은 회색으로 */
  border: 1px solid rgba(0, 0, 0, 0.2); /* 은은한 테두리 */
  border-radius: 8px; /* 부드러운 모서리 */
  padding: 10px 15px; /* 내부 여백 */
  font-size: 1rem; /* 글자 크기 */
  color: #333; /* 텍스트 색상 */
  font-family: 'Noto Sans', sans-serif; /* 고급스러운 글꼴 */
  appearance: none; /* 기본 select 화살표 제거 */
  background-image: url('/path/to/your/custom-arrow-icon.png'); /* 사용자 정의 화살표 아이콘 */
  background-repeat: no-repeat;
  background-position: right 10px center;
  transition: border-color 0.3s ease, box-shadow 0.3s ease;
  box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.05); /* 부드러운 그림자 */
  cursor: pointer;

  &:hover {
    border-color: #0275d8; /* 호버 시 테두리 색상 변경 */
    box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.1); /* 호버 시 그림자 */
  }

  &:focus {
    outline: none;
    border-color: #0275d8; /* 포커스 시 강조 */
    box-shadow: 0px 4px 8px rgba(2, 117, 216, 0.2); /* 포커스 시 그림자 */
  }
`;

export const Option = styled.option`
  background-color: #fff; /* 옵션 배경색 */
  font-size: 1rem;
  color: #333; /* 텍스트 색상 */
  padding: 10px 15px;
  font-family: 'Noto Sans', sans-serif;
  transition: background-color 0.2s ease;

  &:hover {
    background-color: #f1f1f1; /* 옵션 호버 시 배경색 변경 */
  }

  &:checked {
    background-color: #0275d8; /* 선택된 옵션 배경색 */
    color: #fff; /* 선택된 옵션 텍스트 색상 */
  }
`;

export const SearchBtn = styled.div`
  cursor: pointer;
`;

export const DownloadWrapper = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;
  margin-top: 10px;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`;

export const TableHeaderRow = styled.tr``;

export const TableHeader = styled.th`
  background-color: #f5f5f5;
  padding: 10px 15px;
  font-weight: bold;
  font-size: 1rem;
  text-align: center;
  height: 45px;
  line-height: 45px;
  color: #444;
  position: relative; /* 부모 요소에 상대 위치 설정 */
  &::after {
    content: '';
    position: absolute;
    top: 20%; /* 구분선이 상단에서 20% 시작 */
    bottom: 20%; /* 구분선이 하단에서 20% 끝 */
    right: 0;
    width: 1px;
    background-color: rgba(0, 0, 0, 0.05); /* 가벼운 구분선 색상 */
  }
  &:last-child::after {
    content: none; /* 마지막 열에는 구분선 없애기 */
  }
  ${media.small`
    font-size: 0.9rem;
    padding: 8px 10px;
    height: 40px;
    line-height: 40px;
  `}
`;

export const TableHeaderWrap = styled.thead`
  ${'' /* position: sticky; */}
  top: 0;
  z-index: 2;
  background: #f5f5f5;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 300px;
  font-weight: bold;
  background: #e0e0e0;
  color: #333;
  font-size: 1.2rem;
  border-radius: 12px;
`;

export const DownloadBtn = styled.button`
  width: 140px;
  height: 40px;
  background: #48c6ef;
  border-radius: 8px;
  color: white;
  border: none;
  font-weight: bold;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);

  &:hover {
    background: #6f86d6;
    box-shadow: 0px 6px 12px rgba(0, 0, 0, 0.2);
  }
`;
